import PageLayout from '@/components/feature/PageLayout';
import BackToTop from '@/components/feature/BackToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryCards from '@/pages/home/components/CategoryCards';
import FeaturedArticles from '@/pages/home/components/FeaturedArticles';
import FAQSection from '@/pages/home/components/FAQSection';
import CTASection from '@/pages/home/components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '十八禁合规指引平台',
  url: 'https://hyel.com.cn/',
  description:
    '为成年用户提供合规访问指引、内容分级说明及安全使用建议的综合性平台',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://hyel.com.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '十八禁合规指引平台',
  url: 'https://hyel.com.cn/',
  description:
    '国内领先的成人内容合规教育平台，致力于为成年用户和内容行业从业者提供全面、专业、及时的合规知识和实用指引',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@shibajin-compliance.cn',
    telephone: '400-XXX-XXXX',
    contactType: 'customer service',
    availableLanguage: 'Chinese',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '什么是十八禁内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '十八禁内容是指仅适合十八岁以上成年人观看或访问的内容类型。根据不同国家和地区的法律及行业标准，这类内容通常包含成人主题、暴力场景或其他需要年龄限制的敏感内容。',
      },
    },
    {
      '@type': 'Question',
      name: '如何确保未成年人无法访问十八禁内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '有效的未成年人保护机制包括：实施强身份年龄验证（如身份证实名认证、人脸识别等）、建立完善的内容分级过滤系统、提供家长控制工具、开展网络安全教育。',
      },
    },
    {
      '@type': 'Question',
      name: '十八禁内容在中国是否合法？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '中国法律对淫秽内容与成人内容有着明确的界定标准。传播淫秽物品属于违法犯罪行为。对于艺术、教育、医学等正当用途中涉及成人主题的内容，在符合相关法律法规和行业标准的前提下可以进行有限度的传播。',
      },
    },
    {
      '@type': 'Question',
      name: '各国对十八禁内容的监管有什么不同？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '美国采用分级制度，欧洲强调用户权利和数据保护，英国对在线安全提出了严格的年龄验证要求，日本有完善的内容分级自律体系，东南亚国家多采取较为严格的管控政策。',
      },
    },
    {
      '@type': 'Question',
      name: '年龄验证技术有哪些主流方案？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '当前主流的年龄验证技术方案包括：身份证件验证、人脸识别年龄估计、第三方信用验证、银行卡验证、手机号实名校验等。推荐采用分层验证策略。',
      },
    },
    {
      '@type': 'Question',
      name: '平台运营者需要注意哪些合规事项？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '成人内容平台运营者应重点关注：建立健全内容审核机制、实施有效的年龄验证系统、制定清晰的内容分级标准、建立用户举报和投诉处理渠道、保护用户隐私和个人信息安全等。',
      },
    },
  ],
};

export default function Home() {
  return (
    <PageLayout>
      <title>十八禁内容合规指引平台 | 成人内容访问指引与法律边界</title>
      <meta
        name="description"
        content="十八禁内容合规指引平台为成年用户提供合规访问指引、内容分级说明及安全使用建议。深入了解十八禁内容的法律边界、平台规范与未成年人保护机制，确保在合法合规前提下安全浏览。"
      />
      <meta
        name="keywords"
        content="十八禁,十八禁内容分级,十八禁平台合规,成人内容访问指引,十八禁法律边界,未成年人保护机制,十八禁年龄验证"
      />
      <link rel="canonical" href="https://hyel.com.cn/" />
      <meta property="og:title" content="十八禁内容合规指引平台 | 成人内容访问指引与法律边界" />
      <meta
        property="og:description"
        content="为成年用户提供合规访问指引、内容分级说明及安全使用建议。了解十八禁内容的法律边界、平台规范与未成年人保护机制。"
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://hyel.com.cn/" />

      <SchemaOrg data={homeSchema} />
      <SchemaOrg data={orgSchema} />
      <SchemaOrg data={faqSchema} />

      <HeroSection />
      <CategoryCards />
      <FeaturedArticles />
      <CTASection />
      <FAQSection />

      <BackToTop />
    </PageLayout>
  );
}